import isNil from 'lodash/isNil';
import uniqueId from 'lodash/uniqueId';
import {
  VisitNoteServiceCode,
} from 'views/EMR/components/ServiceLookup/type';

export function getInstanceId(item?: VisitNoteServiceCode): string | undefined {
  return item?.__id;
}

export function ensureInstanceId(
  item: VisitNoteServiceCode,
  base: string,
  allowDuplicate: boolean,
): string {
  if (isNil(item)) { return uniqueId(`${base || 'row'}_`); }
  if (item?.__id) { return item?.__id; }

  const id = allowDuplicate
    ? uniqueId(`${base || 'row'}_`)
    : (base || uniqueId('row_'));

  item.__id = id;
  return id;
}

/* TODO: Should be able to use a symbol instead of poluting displayed types
   with extra properties like __id. When I tested, it seemed to fail on editing
   corresponding diagnoses -- something is cloning or copying the service code
   row object without carrying its unique id forward and then the diagnosis
   code popup immediately closes because the row id has changed
*/

/*
export const UNIQ = Symbol.for('ServiceLookup.uniq');

export function getInstanceId(obj: unknown): string | undefined {
  return obj && typeof obj === 'object' ? (obj as any)[UNIQ] : undefined;
}

export function ensureInstanceId<T extends object>(
  obj: T,
  base: string,
  allowDuplicate: boolean,
): string {
  const currId = getInstanceId(obj);
  if (currId) { return currId; }

  const newId = allowDuplicate ? uniqueId(base || 'row_') : (base || uniqueId('row_'));
  Object.defineProperty(obj, UNIQ, { value: newId, enumerable: true });
  return newId;
}
*/
